
export default {
  name: 'icon-schedule',
};
